import { io } from 'socket.io-client';

const serverUrl = process.env.NODE_ENV === 'production'
  ? 'https://task-ui-app.herokuapp.com'
  : 'http://localhost:8080';

const socket = io(serverUrl, {
  withCredentials: true,
});

export default socket;
